import { Directive, OnInit, inject } from '@angular/core';
import { AbstractControl, UntypedFormGroup, Validators } from '@angular/forms';
import ValidatorUtils from '@core/utils/validator.utils';
import {
  DvDynamicFormComponent,
  DvTextareaElement,
  DvTextboxElement,
} from '@devinco/ui/legacy';

@Directive({
  selector: 'dv-dynamic-form',
  standalone: false,
})
export class NoTrailingSpacesInFormDirective implements OnInit {
  private formComponent = inject(DvDynamicFormComponent);

  ngOnInit(): void {
    Object.values(this.formComponent.formGroup.controls).forEach(control => {
      const formElement = this.formComponent.elements.find(
        el =>
          el.options.key ===
          this.getFormControlName(this.formComponent.formGroup, control)
      );
      if (
        control.hasValidator(Validators.required) &&
        (formElement instanceof DvTextboxElement ||
          formElement instanceof DvTextareaElement)
      ) {
        control.addValidators(ValidatorUtils.noWhitespaceValidator);
      }
    });
  }

  private getFormControlName(
    formGroup: UntypedFormGroup,
    control: AbstractControl
  ): string | undefined {
    let controlName;
    Object.keys(formGroup.controls).forEach(key => {
      const childControl = formGroup.get(key);
      if (childControl !== control) {
        return;
      }
      controlName = key;
    });

    return controlName;
  }
}
